export default {
	"Beans.MyGrowingBeans": "我的成长豆",
	"Beans.MarketingMallComponentClick": "营销商城_组件点击",
	"Beans.MarketingMarketplace": "营销商城",
	"Beans.ViewDetails": "查看详情",
	"Beans.MyRedemptionHistory": "我的兑换记录",
	"Beans.RedemptionHistory": "兑换记录"
}